export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 1_07.d05049b1.jpg";